<template>
  <div class="house-box">
    <div class="lef-box">
      <a-tabs v-model:activeKey="typeKey" class="tabs" @tabClick="typeChange">
        <a-tab-pane v-for="items in typeTab" :key="items.value" :tab="items.name">
          <div class="tab-box">
            <div
              v-for="(item, index) in releTab"
              :key="index"
              :class="{
                tabBox: statusKey == item.value,
              }"
              class="tab-none"
              @click="statusChange(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="house-name-search">
            <a-input-search v-model:value="houseName" allowClear placeholder="房源名称" style="width: 100%" @search="getHouseList" @input="debouncedSearch"> </a-input-search>
          </div>
          <div v-if="releList.length" class="lef-con">
            <div v-for="(item, index) in releList" :key="index" class="con-card">
              <div class="card-title">
                <div class="f-w-b">
                  {{ item.name ? item.name : item.rname }}
                </div>
                <div v-if="typeKey == 1" class="f-c-999 f-12">
                  {{ item.rname }}
                </div>
              </div>
              <div class="card-house">
                <div v-if="item.ota_rela.ota_house_id || item.ota_rela.ota_room_id" class="house-info">
                  <img :src="item.ota_rela.coverMedia ? item.ota_rela.coverMedia : item.ota_rela.logo" alt="房源图片" class="house-pic" fit="fill" style="width: 90px; height: 68px" />
                  <div class="house-title">
                    <a-tooltip :mouseEnterDelay="1">
                      <template #title>{{ item.ota_rela.title }}</template>
                      <div class="t-h-2 f-c-000">
                        {{ item.ota_rela.title }}
                      </div>
                    </a-tooltip>
                    <div class="f-12 f-c-999" style="display: flex; align-items: center">
                      <a-avatar :size="20" :src="item.ota_rela.logo"></a-avatar>
                      <span style="margin-left: 2px">{{ item.ota_rela.name }}</span>
                    </div>
                  </div>
                  <div class="del-icon f-16" @click="handleRemove(item)">
                    <close-circle-filled />
                  </div>
                </div>

                <div v-else :class="{ dropIn: item.id === dropInId }" class="house-info noData" @dragenter="dragEnter(item)" @dragleave="dragLeave" @drop="drop($event, item)" @dragover.prevent>
                  <span v-if="item.id === dropInId">松开放置在此处</span>
                  <span v-else>请将右侧的渠道房源<br />拖动到此处进行关联</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="lef-con" style="display: flex; justify-content: center; align-items: center">
            <div style="text-align: center">
              <a-empty :image="simpleImage" />
            </div>
          </div>
        </a-tab-pane>
        <template #rightExtra>
          <a-button v-if="typeKey == 1" class="tab-one" @click="goRouter('/pms/landlord/house/index')">创建新房间 </a-button>
          <a-button v-else class="tab-one" @click="goRouter('/pms/landlord/house/room')">创建新房型 </a-button>
          <!-- <a-button
            class="btn-primary tab-one"
            @click="handleSave"
            :loading="saveNum ? true : false"
            >保存</a-button
          > -->
        </template>
      </a-tabs>
    </div>
    <div class="rig-box">
      <a-tabs v-model:activeKey="activeKey" class="tabs" @tabClick="tabChange">
        <a-tab-pane v-for="(item, index) in otaTab" :key="index">
          <template #tab>
            <!-- <a-badge
              :count="item.house_num"
              :offset="[10, -5]"
              :number-style="{
                padding: 0,
                height: '15px',
                lineHeight: '15px',
              }"
            > -->
            <div>{{ item.ota_name }}</div>
            <!-- </a-badge> -->
          </template>
          <div class="cota-box">
            <div class="cota-scoll">
              <div
                v-for="(itemc, indexc) in item.child"
                :key="indexc"
                :class="{
                  tabBox: cota_id == itemc.cota_id,
                  pointerBottom: cota_id == itemc.cota_id,
                }"
                class="tab-none"
                @click="handleSelTab(itemc)"
              >
                <a-badge
                  :count="itemc.house_num"
                  :number-style="{
                    padding: 0,
                    height: '15px',
                    lineHeight: '15px',
                  }"
                  :offset="[0, -8]"
                >
                  <div class="item-box text-hid" style="text-align: center; width: auto">
                    <div class="box-title f-12">{{ itemc.name }}</div>
                  </div>
                </a-badge>
              </div>
            </div>
            <div class="search-box">
              <a-input-search v-model:value="keyword" allowClear placeholder="房间名称" style="width: 100%" @search="getOtaComHouse"> </a-input-search>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="con-box">
        <div v-if="otaReleList.length" class="house">
          <div class="house-list">
            <template v-for="(item, index) in otaReleList" :key="index">
              <div :id="index" class="house-info" draggable="true" @dragend="dragend($event, index)" @dragstart="dragstart($event, item)">
                <img :src="imgCut(item.coverMedia ? item.coverMedia : item.logo, '')" alt="房源图片" class="house-pic" fit="fill" style="width: 90px; height: 68px" />
                <div class="house-title">
                  <a-tooltip :mouseEnterDelay="1">
                    <template #title>{{ item.title }}</template>
                    <span class="t-h-2 f-c-000">
                      {{ item.title }}
                    </span>
                  </a-tooltip>
                  <div class="f-12 f-c-999" style="display: flex; align-items: center">
                    <a-avatar :size="20" :src="item.logo"></a-avatar>
                    <span style="margin-left: 2px">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-else class="house" style="display: flex; justify-content: center; align-items: center">
          <div style="text-align: center">
            <span class="f-w-b f-16">暂无渠道房源</span>
            <br />请前往渠道账号页面添加账号后读取房源 <br />
            <a-button style="margin-top: 10px" @click="goRouter('/pms/landlord/ota/account')">前往渠道账号 </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import { CloseCircleFilled } from '@ant-design/icons-vue';
import { getOtaAccountList, getOtaComHouseList, otaDelHouseRela, otagetHouseList, otagetRoomList, otaHouseRela } from '@/api/api'; //接口
// import { message } from "ant-design-vue";
import router from '@/router/index';
import { Empty, message } from 'ant-design-vue';

export default {
  components: {
    CloseCircleFilled,
  },
  setup() {
    let { imgCut } = useUtils();

    // 防抖函数
    function debounce(fn, delay = 300) {
      let timer = null;
      return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    }

    // 防抖搜索函数
    const debouncedSearch = debounce(() => {
      tabs.getHouseList();
    }, 300);

    let tabs = reactive({
      keyword: '',
      houseName: '',
      activeKey: 0,
      cota_id: '',
      ota_id: '',
      statusKey: 1,
      typeKey: 1,
      otaTab: [],
      cotaList: [],
      releTab: [
        {
          name: '全部',
          value: 1,
        },
        {
          name: '未关联',
          value: 2,
        },
        {
          name: '已关联',
          value: 3,
        },
      ],
      typeTab: [
        {
          name: '房间',
          value: 1,
        },
        {
          name: '房型',
          value: 2,
        },
      ],
      typeChange(value) {
        console.log(value);
        tabs.typeKey = value;
        tabs.getHouseList();
      },
      statusChange(value) {
        tabs.statusKey = value;
        tabs.getHouseList();
      },
      otaCompany() {
        // if (tabs.typeKey == 1) {
        getOtaAccountList().then(res => {
          tabs.otaTab = res.data;
          tabs.tabChange(tabs.activeKey);
        });
        // } else if (tabs.typeKey == 2) {
        //   getOtaRootAccountList().then((res) => {
        //     tabs.otaTab = res.data;
        //     tabs.tabChange(0);
        //   });
        // }
      },
      tabChange(e) {
        tabs.ota_id = tabs.otaTab[e] ? tabs.otaTab[e].ota_id : 0;
        tabs.cota_id = tabs.otaTab[e] ? tabs.otaTab[e].child[0].cota_id : 0;
        tabs.getOtaComHouse();
        tabs.getHouseList();
      },
      handleSelTab(item) {
        tabs.cota_id = item.cota_id;
        tabs.getOtaComHouse();
        tabs.getHouseList();
      },
      getOtaComHouse() {
        // if (tabs.typeKey == 1) {
        getOtaComHouseList({
          ota_id: tabs.ota_id,
          cota_id: tabs.cota_id,
          type_pms: '0',
          rentType: '1',
          type: tabs.typeKey,
          keyword: tabs.keyword,
          start: 0,
          limit: 999,
        }).then(res => {
          house.otaReleList_o = res.data.list;
          house.otaReleList = res.data.list;
        });
        // } else if (tabs.typeKey == 2) {
        //   getOtaComRoomList({
        //     ota_id: tabs.ota_id,
        //     cota_id: tabs.cota_id,
        //   }).then((res) => {
        //     house.otaReleList = res.data;
        //   });
        // }
      },
      getHouseList() {
        if (tabs.typeKey == 1) {
          otagetHouseList({
            ota_id: tabs.ota_id,
            cota_id: tabs.cota_id,
            type: tabs.statusKey,
            name: tabs.houseName || undefined,
          }).then(res => {
            house.releList = res.data;
          });
        } else if (tabs.typeKey == 2) {
          otagetRoomList({
            ota_id: tabs.ota_id,
            cota_id: tabs.cota_id,
            type: tabs.statusKey,
            name: tabs.houseName || undefined,
          }).then(res => {
            house.releList = res.data;
          });
        }
      },
      goRouter(params) {
        router.push(params);
      },
    });

    let house = reactive({
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      releList: [],
      otaReleList_o: [],
      otaReleList: [],
      dropSign: false, //是否有拖拽事件完成
      dropTip: '请将右侧的单独房源拖动到此处进行关联', //拖拽提示字
      dropInId: false, //拖拽进入信号
      // 拖拽开始
      dragstart(event, item) {
        event.dataTransfer.setData('item', JSON.stringify(item));
      },
      // 拖拽进入
      dragEnter(item) {
        house.dropTip = '松开放置在此处';
        house.dropInId = item.id;
      },
      // 拖拽离开
      dragLeave() {
        house.dropTip = '请将右侧的单独房源拖动到此处进行关联';
        house.dropInId = '';
      },

      // 拖拽放下
      drop(event, item) {
        let data = JSON.parse(event.dataTransfer.getData('item'));
        otaHouseRela({
          id: data.ota_house_id,
          hid: item.id,
          table: tabs.typeKey,
        })
          .then(res => {
            message.success(res.msg);
            house.dropSign = true;
            house.dropInId = '';
            item.ota_rela = [];
            item.ota_rela.push(data);
            getOtaAccountList().then(res => {
              tabs.otaTab = res.data;
            });
            tabs.getOtaComHouse();
            tabs.getHouseList();
          })
          .catch(() => {
            house.dropSign = false;
          });
      },
      // 拖拽结束
      dragend(event) {
        if (house.dropSign) {
          event.dataTransfer.clearData();
          // house.otaReleList.splice(index, 1);
          house.dropSign = false;
        }
      },
      // 移除
      handleRemove(item) {
        otaDelHouseRela({
          id: tabs.typeKey == 1 ? item.ota_rela.ota_house_id : item.ota_rela.ota_room_id,
        }).then(res => {
          message.success(res.msg);
          getOtaAccountList().then(res => {
            tabs.otaTab = res.data;
          });
          tabs.getOtaComHouse();
          tabs.getHouseList();
        });
      },
    });

    onMounted(() => {
      tabs.otaCompany();
      // house.houseList();
    });

    return {
      ...toRefs(tabs),
      ...toRefs(house),
      imgCut,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      debouncedSearch,
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.ant-tabs > .ant-tabs-nav) {
  margin: 0 0 16px 0;
}

.house-box {
  display: flex;
  //   justify-content: space-between;
  // position: relative;
  // bottom: 0;
  height: 100%;

  .lef-box {
    width: 600px;
    box-shadow: 0 1px 8px #5959591f !important;
    background-color: #fff;
    border-radius: 5px;
    margin-right: 10px;
    position: relative;

    .tabs {
      margin: 0 20px;

      .tab-one {
        margin: 0 5px;
      }
    }

    .tab-box {
      display: flex;
      flex-wrap: wrap;
      // padding: 0 20px 10px 20px;

      .tab-none {
        padding: 2px 5px;
        text-align: center;
        border: 1px solid #f3f3f3;
        margin-right: 10px;
        position: relative;
        background-color: #ffffff;
        // color: #FFFFFF;
        border-radius: 5px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .tabBox {
        padding: 2px 5px;
        text-align: center;
        border: 1px solid #f3f3f3;
        margin-right: 10px;
        position: relative;
        background-color: #0094ff;
        color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 5px #f2f2f2;
        cursor: pointer;
        margin-bottom: 10px;
        margin-right: 10px;

        .item-box {
          .box-title {
            // min-width: 80rpx;
          }

          .box-num {
          }
        }
      }
    }

    .house-name-search {
      margin-bottom: 10px;
    }

    .lef-con {
      overflow: auto;
      bottom: 0;
      top: 145px;
      position: absolute;
      right: 20px;
      left: 20px;

      //   padding: 10px;
      .con-card {
        background: #f7f8fa;
        padding: 20px;
        margin-bottom: 20px;

        .card-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .card-house {
          // height: 100px;
          width: auto;
          // border: 1px dashed #999999;
          display: flex;
          border-radius: 5px;
          flex-wrap: wrap;

          .house-info {
            border-radius: 5px;
            width: 53%;
            height: 70px;
            display: flex;
            margin: 10px 10px 10px 0;
            border: 1px solid #f2f2f2;
            background-color: #fff;
            // cursor: move;
            position: relative;
            align-items: center;

            .house-pic {
              margin-right: 10px;
              width: 90px;
              height: 100%;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }

            .house-title {
              flex: 1;
            }

            .del-icon {
              position: absolute;
              right: -6px;
              top: -14px;
              color: #999999;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .rig-box {
    width: 600px;
    box-shadow: 0 1px 8px #5959591f !important;
    background-color: #fff;
    border-radius: 5px;
    // margin: 10px;
    position: relative;
    display: flex;
    flex-direction: column;

    .tabs {
      margin: 0 20px;

      .cota-box {
        // text-align: right;
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .cota-scoll {
          display: flex;
          flex-wrap: wrap;

          .tab-none {
            padding: 2px 5px;
            text-align: center;
            border: 1px solid #f3f3f3;
            margin-right: 5px;
            position: relative;
            background-color: #ffffff;
            // color: #FFFFFF;
            border-radius: 5px;
            margin-bottom: 5px;
            cursor: pointer;
          }

          .tabBox {
            padding: 2px 5px;
            text-align: center;
            border: 1px solid #f3f3f3;
            margin-right: 10px;
            position: relative;
            background-color: #0094ff;
            color: #ffffff;
            border-radius: 5px;
            box-shadow: 0 0 5px #f2f2f2;
            cursor: pointer;
            margin-bottom: 5px;

            .item-box {
              .box-title {
                // min-width: 80rpx;
              }

              .box-num {
              }
            }
          }

          // .tabBox:after {
          //   content: " ";
          //   position: absolute;
          //   height: 0;
          //   width: 0;
          //   border: solid transparent;
          //   pointer-events: none;
          //   border-width: 6px;
          //   // border-color: #FFFFFF;
          // }

          // .pointerBottom {
          //   animation: animimate-pointer--bottom 500ms ease-in-out;
          //   animation-transform-origin: bottom center;
          // }

          // .pointerBottom:after {
          //   margin-left: -8px;
          //   border-top-color: #0094ff;
          //   top: 96%;
          //   left: 50%;
          // }
        }

        .search-box {
          width: 250px;
        }
      }

      .tab-one {
        margin: 0 5px;
      }
    }

    .con-box {
      margin: 0 10px;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      // position: absolute;
      // bottom: 0;
      position: relative;
      flex: 1;

      .house {
        bottom: 0;
        top: 0;
        position: absolute;
        right: 10px;
        left: 10px;
        overflow: auto;

        .house-type {
          margin-bottom: 10px;
        }

        .house-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          cursor: move;

          .house-info {
            border-radius: 5px;
            width: 48%;
            height: 70px;
            display: flex;
            align-items: center;
            margin: 10px 10px 10px 0;
            border: 1px solid #f2f2f2;

            .house-pic {
              margin-right: 10px;
              width: 90px !important;
              height: 100%;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }

            .house-title {
              flex: 1;
            }
          }
        }
      }
    }
  }
}

.noData {
  background-color: #f7f8fa !important;
  border: 1px dashed #999999 !important;
  justify-content: center;
  align-items: center;
  color: #999999;
  padding: 0 40px;
}

.dropIn {
  color: #1890ff;
  border: 1px dashed #1890ff !important;
}

:deep(.ant-badge) {
  color: unset !important;
}
</style>
